export const capitalize = (str) => str
  .toLowerCase()
  .split(' ')
  .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
  .join(' ');
export const anyToPascalCase = (str, separator) => str
  .toLowerCase()
  .split(separator)
  .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
  .join('');
export const dashToPascalCase = (str) => anyToPascalCase(str, '-');
export const underscoreToPascalCase = (str) => anyToPascalCase(str, '_');
export const hashCode = (str) => {
  str = typeof str === "object" ? JSON.stringify(str) : str;
  let hash = 0, i, chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr   = str.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return `h${Math.abs(hash)}`;
};